var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      attrs: { id: "mortgage-calculators-container" },
    },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { staticClass: "px-md-5", attrs: { cols: "12" } },
            [
              _c("page-header", {
                attrs: {
                  title: _vm.$t("financial-tools.mortgageCalculators"),
                  subtitle: _vm.$t("financial-tools.subtitle"),
                  "title-class": "page-header text-capitalize",
                },
              }),
              _vm._v(" "),
              _c("mortgage-calculators-tabs"),
              _vm._v(" "),
              _c("router-view", {
                ref: "toolsContainer",
                attrs: {
                  loading: _vm.loading,
                  "running-report": _vm.runningReport,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }